(function(){
  'use strict';

  function money(cents){
    var currency='USD';
    try{ if(window.Shopify && Shopify.currency && Shopify.currency.active) currency=Shopify.currency.active; }catch(e){}
    return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency}).format((Number(cents)||0)/100);
  }

  function showProduct(pushHash){
    if(!document.body.classList.contains('template-index')) return;
    document.body.classList.add('plume-product-active');
    if(pushHash && location.hash!=='#plume-product-view') history.pushState({plumeView:'product'},'', '#plume-product-view');
    window.scrollTo({top:0,behavior:'auto'});
  }

  function showHome(pushUrl){
    if(!document.body.classList.contains('template-index')) return;
    document.body.classList.remove('plume-product-active');
    if(pushUrl && location.hash) history.pushState({plumeView:'home'},'',location.pathname+location.search);
    window.scrollTo({top:0,behavior:'auto'});
  }

  function initGallery(root){
    if(!root) return;
    root.querySelectorAll('[data-gallery-thumb]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var main=root.querySelector('[data-gallery-main]');
        if(!main) return;
        root.querySelectorAll('[data-gallery-thumb]').forEach(function(x){x.setAttribute('aria-pressed','false');});
        btn.setAttribute('aria-pressed','true');
        var src=btn.dataset.src;
        var alt=btn.dataset.alt||'';
        if(src){
          main.innerHTML='';
          var img=document.createElement('img');
          img.src=src; img.alt=alt; img.loading='eager';
          main.appendChild(img);
        }
      });
    });
  }

  function initDemoControls(root){
    if(!root || root.hasAttribute('data-plume-product')) return;
    root.querySelectorAll('[data-demo-swatch]').forEach(function(btn){
      btn.addEventListener('click',function(){
        root.querySelectorAll('[data-demo-swatch]').forEach(function(x){x.setAttribute('aria-pressed','false');});
        btn.setAttribute('aria-pressed','true');
        var label=root.querySelector('[data-demo-color-label]');
        if(label) label.textContent=btn.dataset.demoColor||'';
      });
    });
    root.querySelectorAll('[data-demo-size]').forEach(function(btn){
      btn.addEventListener('click',function(){
        root.querySelectorAll('[data-demo-size]').forEach(function(x){x.setAttribute('aria-pressed','false');});
        btn.setAttribute('aria-pressed','true');
      });
    });
    root.querySelectorAll('[data-demo-bundle]').forEach(function(btn){
      btn.addEventListener('click',function(){
        root.querySelectorAll('[data-demo-bundle]').forEach(function(x){x.setAttribute('aria-pressed','false');});
        btn.setAttribute('aria-pressed','true');
      });
    });
  }

  function initProduct(root){
    if(!root || !root.hasAttribute('data-plume-product')) return;
    var jsonEl=root.querySelector('[data-variants-json]');
    if(!jsonEl) return;
    var variants=[];
    try{ variants=JSON.parse(jsonEl.textContent||'[]'); }catch(e){ console.error('Plume variant JSON error',e); }
    if(!variants.length) return;

    var optionButtons=Array.from(root.querySelectorAll('[data-option-button]'));
    var variantIdInput=root.querySelector('input[name="id"]');
    var qtyInput=root.querySelector('input[name="quantity"]');
    var addButton=root.querySelector('[data-add-button]');
    var priceEl=root.querySelector('[data-product-price]');
    var compareEl=root.querySelector('[data-compare-price]');
    var buttonPrice=root.querySelector('[data-button-price]');
    var stickyPrice=document.querySelector('[data-sticky-price]');
    var bundleButtons=Array.from(root.querySelectorAll('[data-bundle]'));
    var selectedOptions={};
    var selectedQty=1;
    var displayDiscountCents=0;

    optionButtons.forEach(function(btn){
      if(btn.getAttribute('aria-pressed')==='true') selectedOptions[btn.dataset.optionPosition]=btn.dataset.optionValue;
      btn.addEventListener('click',function(){
        var pos=btn.dataset.optionPosition;
        root.querySelectorAll('[data-option-button][data-option-position="'+pos+'"]').forEach(function(x){x.setAttribute('aria-pressed','false');});
        btn.setAttribute('aria-pressed','true');
        selectedOptions[pos]=btn.dataset.optionValue;
        var label=root.querySelector('[data-option-label="'+pos+'"]');
        if(label) label.textContent=btn.dataset.optionValue;
        updateVariant();
      });
    });

    function findVariant(){
      var exact=variants.find(function(v){
        return Object.keys(selectedOptions).every(function(k){ return v.options[Number(k)-1]===selectedOptions[k]; });
      });
      return exact || variants.find(function(v){return v.available;}) || variants[0];
    }

    function updateVariant(){
      var v=findVariant(); if(!v) return;
      if(variantIdInput) variantIdInput.value=v.id;
      if(priceEl) priceEl.textContent=money(v.price);
      if(compareEl){
        if(v.compare_at_price && v.compare_at_price>v.price){ compareEl.textContent=money(v.compare_at_price); compareEl.style.display='inline'; }
        else { compareEl.textContent=''; compareEl.style.display='none'; }
      }
      var bundleTotal=Math.max(0,(v.price*selectedQty)-displayDiscountCents);
      if(buttonPrice) buttonPrice.textContent=money(bundleTotal);
      if(stickyPrice) stickyPrice.textContent=money(bundleTotal);
      if(addButton){ addButton.disabled=!v.available; addButton.classList.toggle('is-disabled',!v.available); }
      bundleButtons.forEach(function(b){
        var qty=Number(b.dataset.qty||1);
        var off=Number(b.dataset.offCents||0);
        var full=v.price*qty;
        var total=Math.max(0,full-off);
        var p=b.querySelector('[data-bundle-price]');
        var s=b.querySelector('[data-bundle-save]');
        var each=b.querySelector('[data-bundle-each]');
        var compare=b.querySelector('[data-bundle-compare]');
        if(p) p.textContent=money(total);
        if(s) s.textContent=off ? 'Save '+money(off) : 'Single blanket';
        if(each) each.textContent=qty>1 ? ' — '+money(total/qty)+' each' : '';
        if(compare){ compare.textContent=off?money(full):''; compare.style.display=off?'block':'none'; }
      });
    }

    bundleButtons.forEach(function(b){
      b.addEventListener('click',function(){
        bundleButtons.forEach(function(x){x.setAttribute('aria-pressed','false');});
        b.setAttribute('aria-pressed','true');
        selectedQty=Number(b.dataset.qty||1);
        displayDiscountCents=Number(b.dataset.offCents||0);
        if(qtyInput) qtyInput.value=selectedQty;
        updateVariant();
      });
    });

    var form=root.querySelector('form[action*="/cart/add"]');
    if(form){
      form.addEventListener('submit',async function(e){
        e.preventDefault();
        var v=findVariant();
        if(!v || !v.available) return;
        if(addButton){addButton.disabled=true;addButton.dataset.originalText=addButton.innerHTML;addButton.innerHTML='Adding…';}
        try{
          var response=await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'cart/add.js',{
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[{id:v.id,quantity:selectedQty}]})
          });
          if(!response.ok){
            var err=await response.json().catch(function(){return {};});
            throw new Error(err.description||'Could not add this item to cart.');
          }
          window.location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'cart';
        }catch(err){
          alert(err.message||'Could not add this item to cart.');
          if(addButton){addButton.disabled=false;addButton.innerHTML=addButton.dataset.originalText||'Add to cart';}
        }
      });
    }
    updateVariant();
  }

  document.addEventListener('DOMContentLoaded',function(){
    document.querySelectorAll('[data-plume-product-view], [data-plume-product]').forEach(function(root){
      initGallery(root);
      initDemoControls(root);
      initProduct(root);
    });

    document.querySelectorAll('[data-sticky-add]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var target=document.querySelector('.plume-product-active [data-add-button], [data-plume-product] [data-add-button]');
        if(target) target.click();
      });
    });

    document.addEventListener('click',function(e){
      var productLink=e.target.closest('a[href="#plume-product-view"], [data-plume-show-product]');
      if(productLink && document.body.classList.contains('template-index')){ e.preventDefault(); showProduct(true); return; }
      var homeLink=e.target.closest('[data-plume-show-home]');
      if(homeLink && document.body.classList.contains('template-index')){ e.preventDefault(); showHome(true); }
    });

    window.addEventListener('popstate',function(){
      if(!document.body.classList.contains('template-index')) return;
      if(location.hash==='#plume-product-view') showProduct(false); else showHome(false);
    });

    if(document.body.classList.contains('template-index') && location.hash==='#plume-product-view') showProduct(false);
  });
})();
